export default __webpack_public_path__ + "static/sb-logo-footer-c55476ede577afbf344348f747039a33.svg";